"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("@fluentui/react");
require("./Forms.scss");
require("./CustomTextField.scss");
var CustomLabel_1 = require("./CustomLabel");
var InputType;
(function (InputType) {
    InputType[InputType["None"] = 0] = "None";
    InputType[InputType["Number"] = 1] = "Number";
    InputType[InputType["DecimalNumber"] = 2] = "DecimalNumber";
    InputType[InputType["LetterOnly"] = 3] = "LetterOnly";
})(InputType = exports.InputType || (exports.InputType = {}));
var CustomTextField = function (props) {
    var validationFunc = props.validationFunc, onValidationChange = props.onValidationChange, errorMessageFromProps = props.errorMessage, value = props.value, isManualErrorMessageBlock = props.isManualErrorMessageBlock, inputType = props.inputType, className = props.className, readOnly = props.readOnly, required = props.required, arabic = props.arabic, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, onChange = props.onChange, containerClassName = props.containerClassName, disabled = props.disabled;
    var _a = react_1.useState(), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = react_1.useState(undefined), isValid = _b[0], setIsValid = _b[1];
    var onChangeValue = react_1.useCallback(function (val) {
        var newIsValid = true;
        var previousError = errorMessage;
        if (errorMessageFromProps) {
            if (previousError !== errorMessageFromProps) {
                setErrorMessage(errorMessageFromProps);
            }
            if (isManualErrorMessageBlock) {
                newIsValid = false;
            }
        }
        else if (validationFunc) {
            var error = validationFunc(val !== null && val !== void 0 ? val : '');
            if (previousError !== error) {
                setErrorMessage(error);
            }
            if (error) {
                newIsValid = false;
            }
        }
        if (newIsValid !== isValid) {
            setIsValid(newIsValid);
            if (newIsValid) {
                if (previousError) {
                    if (!isManualErrorMessageBlock || !errorMessageFromProps) {
                        setErrorMessage(undefined);
                    }
                }
            }
            if (onValidationChange) {
                onValidationChange(newIsValid);
            }
        }
    }, [
        errorMessageFromProps,
        errorMessage,
        isValid,
        isManualErrorMessageBlock,
        onValidationChange,
        validationFunc,
    ]);
    react_1.useEffect(function () {
        if (onValidationChange) {
            if (validationFunc) {
                var error = validationFunc(value);
                if (error === undefined && errorMessage) {
                    setErrorMessage(undefined); // when value change by binding remove the previous error message
                }
                onValidationChange(error === undefined);
            }
            else {
                onValidationChange(true);
            }
        }
    }, [value, onValidationChange, validationFunc]);
    var checkFormat = function (val) {
        if (inputType && val) {
            switch (inputType) {
                case InputType.Number:
                    return /^[0-9]+$/.test(val);
                case InputType.DecimalNumber:
                    return /^[0-9]+\.?[0-9]*$/.test(val);
                case InputType.LetterOnly:
                    // eslint-disable-next-line no-useless-escape
                    return /^[a-zA-Z ,-@\(\)]+$/.test(val);
                default:
                    return true;
            }
        }
        return true;
    };
    var useClassName = clsx_1.default(className, readOnly ? 'eta-cTextFieldReadOnly' : '', arabic ? 'rtlTextField' : '');
    var label = props.label;
    return (react_1.default.createElement("div", { className: clsx_1.default('vertialFlexDiv', containerClassName) },
        label && (react_1.default.createElement(CustomLabel_1.Label, { required: required, toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
        react_1.default.createElement(react_2.TextField, __assign({}, props, { label: undefined, required: undefined, className: useClassName, errorMessage: readOnly || disabled ? undefined : errorMessageFromProps !== null && errorMessageFromProps !== void 0 ? errorMessageFromProps : errorMessage, value: value !== null && value !== void 0 ? value : '', onChange: function (e, v) {
                if (checkFormat(v)) {
                    onChangeValue(v);
                    if (onChange) {
                        onChange(e, v);
                    }
                }
            } }))));
};
exports.TextField = CustomTextField;
//# sourceMappingURL=CustomTextField.js.map